module.exports = __webpack_public_path__ + "img/img-75.84c59b54.png";